/* Exporting external process state default object. */
export default {
  processData: {},
  process: "",
};
